import React from 'react';
import theme from './styles/theme'
import { ThemeProvider } from '@material-ui/core';
import Login from './screen/login';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Dashboard from './screen/dashboard';
import Unauthorized from './screen/unauthorized';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="unauthorized" element={<Unauthorized />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
